import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RescheduleForAction from "../interview/RescheduleForAction";
import CancelInterview from "../../Vendor/interview/CancelInterviewComponent";
import { useNavigate } from "react-router-dom";

const ITEM_HEIGHT = 48;

function DotsMenu({ data, pageNumber }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const canShowMenu =
    data?.actionPerformed == null &&
    data?.candidateInterviewStatus !== "REJECT";

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        onClick={handleClick}
        size="small"
        sx={{ p: 0, m: 0 }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      {canShowMenu && (
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ "aria-labelledby": "long-button" }}
          PaperProps={{
            style: { maxHeight: ITEM_HEIGHT * 4.5, width: "15ch" },
          }}
        >
          {/* Reschedule Only If Interview Was Cancelled */}
          {data?.interviewStatus === "CANCELLED" && (
            <MenuItem onClick={(e) => e.stopPropagation()}>
              <RescheduleForAction
                setAnchorEl={setAnchorEl}
                pageNumber={pageNumber}
                data={data}
                text="Reschedule"
              />
            </MenuItem>
          )}

          {/* Next Round */}
          {(data?.candidateInterviewStatus === "NEXT_ROUND" ||
            data?.candidateInterviewStatus === "ONHOLD") && (
            <MenuItem onClick={(e) => e.stopPropagation()}>
              <RescheduleForAction
                setAnchorEl={setAnchorEl}
                pageNumber={pageNumber}
                data={data}
                text="Next Round"
              />
            </MenuItem>
          )}

          {/* Cancel Button (Exclude space bug) */}
          {data?.interviewStatus !== "CANCELLED" && (
            <MenuItem onClick={(e) => e.stopPropagation()}>
              <CancelInterview
                setAnchorEl={setAnchorEl}
                pageNumber={pageNumber}
                data={data?.interviewId}
                text="Cancel"
              />
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
}

// -----------------------------------------------------------------------------------------------------

const InterviewList = ({ interviewList, limit, pageNumber }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const [y, m, d] = dateString.split(" ")[0].split("-");
    return `${d}-${m}-${y}`;
  };

  return (
    <div className="mt-3 common_shadow">
      <div className="card-header common_table_header">
        Scheduled Interviews
      </div>

      <div className="card-body">
        <div className="table-responsive">
          <table
            className="table-data"
            style={{ width: "100%", textAlign: "center", fontSize: "14px" }}
          >
            <thead>
              <tr>
                <th>Job ID</th>
                <th>Candidate Name</th>
                {!limit && <th>Round</th>}
                <th>Designation</th>
                <th>Date</th>
                <th>Start Time</th>
                <th>Duration</th>

                {!limit && <th>Interview Type</th>}
                {!limit && <th>Interview Status</th>}

                {!limit && <th style={{ minWidth: "90px" }}>Action</th>}
              </tr>
            </thead>

            <tbody>
              {interviewList?.content?.length > 0 ? (
                interviewList?.content?.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/job-details/${item.jobId}`)}
                    >
                      {item.jobUuid}
                    </td>

                    <td>{item.candidateName}</td>

                    {!limit && (
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/interview_all_rounds/${item.uuid}`, {
                            state: { myData: "candidate" },
                          })
                        }
                      >
                        {item.round}
                      </td>
                    )}

                    <td>{item.jobPosition}</td>
                    <td>{formatDate(item?.interviewDate)}</td>
                    <td>{item.interviewStartTime}</td>
                    <td>{item.duration}</td>

                    {!limit && <td>{item.inteviewType}</td>}

                    {!limit && (
                      <td>
                        <div
                          className={`status-badge ${
                            ["ONHOLD", "PENDING"].includes(
                              item.candidateInterviewStatus
                            )
                              ? "yellow_status"
                              : ["CANCELLED", "REJECT"].includes(
                                  item.candidateInterviewStatus
                                )
                              ? "red_status"
                              : ["SELECT", "NEXT_ROUND"].includes(
                                  item.candidateInterviewStatus
                                )
                              ? "green_status"
                              : ""
                          }`}
                        >
                          {item.candidateInterviewStatus.replace("_", " ")}
                        </div>
                      </td>
                    )}

                    {!limit && (
                      <td>
                        {["SELECT", "ONHOLD", "REJECT"].includes(
                          item.candidateInterviewStatus
                        ) ? (
                          "N/A"
                        ) : (
                          <DotsMenu pageNumber={pageNumber} data={item} />
                        )}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={limit ? 7 : 10}
                    style={{
                      textAlign: "center",
                      padding: "20px 28px",
                      backgroundColor: "#f8fafc",
                      color: "#475569",
                      fontFamily: "'Poppins', 'Segoe UI', Tahoma, sans-serif",
                      fontSize: "1.2rem",
                      fontWeight: "500",
                      fontStyle: "italic",
                      borderRadius: "8px",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                      letterSpacing: "0.5px",
                    }}
                  >
                    <span style={{ opacity: 0.8 }}>
                      ✨{" "}
                      <strong>
                        <em>No Data Available</em>
                      </strong>{" "}
                      ✨
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InterviewList;
